module.exports = __webpack_public_path__ + "media/08_ASANBUDAPEST-BEATS08.4aad0ba8.mp3";